import React from 'react';
import './Latestevent.css';
import a from '../assets/images/k.jpg';
import b from '../assets/images/tt.jpg';
import r from '../assets/images/n.jpg';
import s from '../assets/images/l.jpg';
import j from '../assets/images/p.jpg';
import g from '../assets/images/a.jpg';

const Latestevent = () => {
  const eventUpdates = [
    {
      id: 1,
      image: a,
      category: 'Event Updates',
      time: '3 min ago',
      title: 'Chandigarh is booking up for a new singles event this week',
      description: 'Chandigarh is booking up for a new singles event this week. Chandigarh is booking.....',
      author: 'Harkaran Singh',
      authorAvatar: '/img.png'
    },
    {
      id: 2,
      image: b,
      category: 'Event Updates',
      time: '3 min ago',
      title: 'Chandigarh is booking up for a new singles event this week',
      description: 'Chandigarh is booking up for a new singles event this week. Chandigarh is booking.....',
      author: 'Harkaran Singh',
      authorAvatar: '/img.png'
    },
    {
      id: 3,
      image: r,
      category: 'Event Updates',
      time: '3 min ago',
      title: 'Chandigarh is booking up for a new singles event this week',
      author: 'Harkaran Singh',
      authorAvatar: '/img.png'
    },
    {
      id: 4,
      image: s,
      category: 'Event Updates',
      time: '3 min ago',
      title: 'Chandigarh is booking up for a new singles event this week',
      author: 'Harkaran Singh',
      authorAvatar: '/img.png'
    },
    {
      id: 5,
      image: j,
      category: 'Event Updates',
      time: '3 min ago',
      title: 'Chandigarh is booking up for a new singles event this week',
      description: 'Chandigarh is booking up for a new singles event this week. Chandigarh is booking.....',
      author: 'Harkaran Singh',
      authorAvatar: '/img.png'
    },
    {
      id: 6,
      image: g,
      category: 'Event Updates',
      time: '3 min ago',
      title: 'Chandigarh is booking up for a new singles event this week',
      description: 'Chandigarh is booking up for a new singles event this week. Chandigarh is booking.....',
      author: 'Harkaran Singh',
      authorAvatar: '/img.png'
    }
  ];

  return (
    <section className="latest-event-section">
      
      <div className="latest-event-container">
        {/* Badge */}
        <div className="latest-badge">Latest from Event House</div>

        {/* Main Content */}
        <div className="latest-content">
          {/* Left Side - Event Cards */}
          <div className="event-cards-grid">
            {/* Large horizontal cards */}
            <div className="event-card large-card">
              <div className="card-image">
                <img src={eventUpdates[0].image} alt={eventUpdates[0].title} />
              </div>
              <div className="card-content">
                <div className="card-meta">
                  <span className="card-category">{eventUpdates[0].category}</span>
                  <span className="card-time">{eventUpdates[0].time}</span>
                </div>
                <h3 className="card-title">{eventUpdates[0].title}</h3>
                <p className="card-description">{eventUpdates[0].description}</p>
                <div className="card-author">
                  <img src={eventUpdates[0].authorAvatar} alt={eventUpdates[0].author} className="author-avatar" />
                  <div className="author-info">
                    <span className="author-namee">{eventUpdates[0].author}</span>
                    <span className="author-labele">Author</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="event-card large-card">
              <div className="card-image">
                <img src={eventUpdates[1].image} alt={eventUpdates[1].title} />
              </div>
              <div className="card-content">
                <div className="card-meta">
                  <span className="card-category">{eventUpdates[1].category}</span>
                  <span className="card-time">{eventUpdates[1].time}</span>
                </div>
                <h3 className="card-title">{eventUpdates[1].title}</h3>
                <p className="card-description">{eventUpdates[1].description}</p>
                <div className="card-author">
                  <img src={eventUpdates[1].authorAvatar} alt={eventUpdates[1].author} className="author-avatar" />
                  <div className="author-info">
                    <span className="author-namee">{eventUpdates[1].author}</span>
                    <span className="author-labele">Author</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Small vertical cards */}
            {eventUpdates.slice(2, 6).map((event) => (
              <div key={event.id} className="event-card small-card">
                <div className="card-image">
                  <img src={event.image} alt={event.title} />
                </div>
                <div className="card-content">
                  <div className="card-meta">
                    <span className="card-category">{event.category}</span>
                    <span className="card-time">{event.time}</span>
                  </div>
                  <h3 className="card-title">{event.title}</h3>
                  <div className="card-author">
                    <img src={event.authorAvatar} alt={event.author} className="author-avatar" />
                    <div className="author-info">
                      <span className="author-namee">{event.author}</span>
                      <span className="author-labele">Author</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side - Insights */}
          <div className="insights-section">
            <div className="insights-card">
              <div className="insights-image">
                <img src="/Mask group-4.webp" alt="Insights" />
              </div>
              <div className="insights-content">
                <h2 className="insights-title">Insights</h2>
                <p className="insights-description">
                  Stories, updates, and moments from our community along with announcements for upcoming experiences.
                </p>
                <div className="insights-buttons">
                  <a href="/events" className="btn-view-all">View All</a>
                  <a href="/events" className="btn-join">Join the Next Mulaqaat</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Latestevent;
